import React, { Component, Fragment } from "react";
import { NavLink, withRouter } from "react-router-dom";

import { NAME } from "../../../../constants";

// Externals
import classNames from "classnames";
import compose from "recompose/compose";
import PropTypes from "prop-types";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { logout as logoutAction } from "../../../../redux/actions/authActions";
import InviteUser from "../RightSidebar/InviteUserForm";

// Material helpers
import { withStyles } from "@material-ui/core";

import _ from "lodash";

import { getUserDisplayName } from "../../../../utils";

// Material components
import {
  Avatar,
  Box,
  Button,
  Divider,
  IconButton,
  Link,
  Menu,
  MenuItem,
  Popover,
  Toolbar,
  Tooltip,
  Typography
} from "@material-ui/core";

// Material icons
import {
  Menu as MenuIcon,
  Close as CloseIcon,
  AccountBox as AccountBoxIcon,
  KeyboardArrowDown as DownIcon,
  Share as ShareIcon,
  ExitToApp as ExitToAppIcon,
  HelpOutline as HelpOutlineIcon,
  BugReport as BugReportIcon,
  ListAlt as ListAltIcon
} from "@material-ui/icons";

// Material Design Icons https://materialdesignicons.com/

// Component styles
import styles from "./styles";
import "./topbar.css";

class Topbar extends Component {
  constructor(props) {
    super(props);
    this.onSignOut = this.onSignOut.bind(this);
  }

  signal = true;

  state = {
    notifications: [],
    notificationsLimit: 4,
    notificationsCount: 0,
    notificationsEl: null,
    anchorEl: null,
    openInviteDialog: false
  };

  componentDidMount() {
    this.signal = true;
    //load Responsum Issue Collector if not part of the document
    let scripts = Array.prototype.slice.call(document.getElementsByTagName("script"), 0);
    scripts.filter(e =>
      e.src.startsWith("https://iolap-inc.atlassian.net/s/d41d8cd98f00b204e9800998ecf8427e-T") ||
      e.src.startsWith("window.ATL_JQ_PAGE_PROPS")
        ? e.remove()
        : false
    );

    const script = document.createElement("script");
    script.src =
      "https://iolap-inc.atlassian.net/s/d41d8cd98f00b204e9800998ecf8427e-T/-w83ft0/b/12/a44af77267a987a660377e5c46e0fb64/_/download/batch/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector.js?locale=en-US&collectorId=dc232e70";
    script.async = true;
    document.body.appendChild(script);
    const trigger = document.createElement("script");
    trigger.type = "text/javascript";

    trigger.innerHTML = `
      window.ATL_JQ_PAGE_PROPS =  {
        "triggerFunction": function(showCollectorDialog) {
          //Requires that jQuery is available!
          jQuery("#bugCollector").click(function(e) {
            e.preventDefault();
            showCollectorDialog();
          });

          $(function () {
            $('body').on('click', '#bugCollector2', function(e) {
              e.preventDefault();
              showCollectorDialog();
            });

          });
        }};`;
    document.body.appendChild(trigger);
  }

  componentDidUpdate() {}

  componentWillUnmount() {
    this.signal = false;
  }

  onSignOut() {
    // logout
    this.props.action.logoutAction({ username: "admin" }, this.props.history);
  }

  handleShowNotifications = event => {
    this.setState({
      notificationsEl: event.currentTarget
    });
  };

  handleCloseNotifications = () => {
    this.setState({
      notificationsEl: null
    });
  };

  // dropdown on avatar name
  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  // dropdown on avatar name
  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  toggleInviteUser = e => {
    this.setState({
      openInviteDialog: !this.state.openInviteDialog
    });
  };

  render() {
    const { classes, className, isSidebarOpen, onToggleSidebar, toggleRightSidebar, iFrameDetection } = this.props;
    const { notifications, notificationsCount, notificationsEl } = this.state;

    const rootClassName = classNames(classes.root, className);

    const showNotifications = Boolean(notificationsEl);

    // dropdown on avatar name
    const { anchorEl } = this.state;

    const FancyButton = React.forwardRef((props, ref) => (
      <NavLink to="/profile" ref={ref}>
        {props.children}
      </NavLink>
    ));

    return (
      <Fragment>
        <div className={rootClassName} id="topbar-container">
          <Toolbar className={classes.toolbar}>
            {iFrameDetection ? (
              <IconButton
                id="main-menu-button"
                className="main-menu-button--hidden"
                onClick={onToggleSidebar}
                variant="text"
              >
                {isSidebarOpen ? <CloseIcon /> : <MenuIcon />}
              </IconButton>
            ) : (
              <IconButton id="main-menu-button" className={classes.menuButton} onClick={onToggleSidebar} variant="text">
                {isSidebarOpen ? <CloseIcon /> : <MenuIcon />}
              </IconButton>
            )}

            <div className={classes.logoWrapper}>
              <Link to="/dashboard" underline="none" className={classes.logoLink}>
                <Typography className={classes.nameText} underline="none" variant="h3">
                  <img alt="Responsum" className={classes.logoImage} src="/images/logos/logo-dark-background-02.png" />
                </Typography>
              </Link>
            </div>

            <div className={classes.userContainer}>
              <Box display={{ xs: "none", sm: "block" }}>
                <div className={classes.hideShowBoxContainer}>
                  <Tooltip title="Report a bug or missing feature">
                    <IconButton id="bugCollector" className={classes.icon}>
                      <BugReportIcon />
                    </IconButton>
                  </Tooltip>
                  {false && (
                    <IconButton id="help" className={classes.lastIcon} onClick={toggleRightSidebar}>
                      <HelpOutlineIcon />
                    </IconButton>
                  )}
                </div>
              </Box>
              <Button
                aria-owns={anchorEl ? "simple-menu" : undefined}
                aria-haspopup="true"
                onClick={this.handleClick}
                className={classes.navbarUsername}
              >
                {!this.props.isMobile ? getUserDisplayName(this.props.cognitoUser) : undefined}
                {!this.props.isMobile ? <DownIcon className={classes.navbarUsernameDropdown} /> : <span />}
                <Avatar
                  alt={getUserDisplayName(this.props.cognitoUser)}
                  src={_.get(
                    this.props.cognitoUser.attributes,
                    "picture",
                    "https://cdn.pixabay.com/photo/2016/04/01/11/25/avatar-1300331_960_720.png"
                  )}
                  className={classes.navbarAvatar}
                />
              </Button>

              <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                classes={{ paper: classes.dropdownMenu, list: classes.dropdownMenuList }}
                getContentAnchorEl={null}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                open={Boolean(anchorEl)}
                onClose={this.handleClose}
              >
                <NavLink to="/profile" className={classes.dropdownMenuLink}>
                  <MenuItem onClick={this.handleClose} className={classes.dropdownMenuItem}>
                    <Divider variant="middle" className={classes.divider} />
                    <div className={classes.iconAndText}>
                      <AccountBoxIcon className={classes.dropdownIcon} />
                      <Typography className={classes.dropdownMenuText}>Profile</Typography>
                    </div>
                  </MenuItem>
                </NavLink>
                <Link underline="none" className={classes.dropdownMenuLink}>
                  <MenuItem onClick={this.handleClose} className={classes.dropdownMenuItem}>
                    <Divider variant="middle" className={classes.divider} />
                    <div onClick={this.toggleInviteUser} className={classes.iconAndText}>
                      <ShareIcon className={classes.dropdownIcon} />
                      <Typography className={classes.dropdownMenuText}>Invite</Typography>
                    </div>
                    <Divider variant="middle" className={classes.divider} />
                  </MenuItem>
                </Link>

                <Link className={classes.dropdownMenuLink}>
                  <MenuItem onClick={this.handleClose} className={classes.dropdownMenuItem}>
                    <Divider variant="middle" className={classes.divider} />
                    <a
                      href="http://responsum.ai/privacy-policy"
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={this.preventDefault}
                      underline="none"
                      style={{ textDecoration: "none", color: "inherit" }}
                      className={classes.iconAndText}
                    >
                      <ListAltIcon className={classes.dropdownIcon} />
                      <Typography className={classes.dropdownMenuText}>Privacy Policy</Typography>
                    </a>
                    <Divider variant="middle" className={classes.divider} />
                  </MenuItem>
                </Link>

                <Box display={{ xs: "block", sm: "none" }}>
                  <MenuItem className={classes.dropdownMenuItem} id="help" onClick={toggleRightSidebar}>
                    <div className={classes.iconAndText}>
                      <HelpOutlineIcon className={classes.dropdownIcon} />
                      <Typography className={classes.dropdownMenuText}>Help</Typography>
                    </div>
                    <Divider variant="middle" className={classes.divider} />
                  </MenuItem>

                  <MenuItem id="bugCollector2" className={classes.dropdownMenuItem}>
                    <div className={classes.iconAndText}>
                      {/*<BugReportIcon id="bugCollector" className={classes.dropdownIcon} />*/}

                      {/*  <IconButton id="bugCollector" className={classes.icon}>*/}
                      {/*    <BugReportIcon />*/}
                      {/*  </IconButton>*/}

                      {/*<IconButton id="bugCollector" className={classes.icon}>*/}
                      <BugReportIcon className={classes.dropdownIcon} />

                      <Typography className={classes.dropdownMenuText}>Report Bug</Typography>
                    </div>
                    <Divider variant="middle" className={classes.divider} />
                  </MenuItem>
                </Box>

                {/*<Divider variant="middle" className={classes.divider} />*/}
                <MenuItem onClick={this.onSignOut} classes={{ root: classes.dropdownMenuItem }}>
                  <div className={classes.iconAndText}>
                    <ExitToAppIcon className={classes.dropdownIcon} />
                    <Typography className={classes.dropdownMenuText}>Logout</Typography>
                  </div>
                </MenuItem>
              </Menu>
            </div>
          </Toolbar>
        </div>
        <Popover
          className={classes.dropdownMenu}
          anchorEl={notificationsEl}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center"
          }}
          onClose={this.handleCloseNotifications}
          open={showNotifications}
          transformOrigin={{
            vertical: "top",
            horizontal: "center"
          }}
          className={classes.dropdownMenu}
        />
        <InviteUser openDialog={this.state.openInviteDialog} toggleRightSidebar={this.toggleInviteUser} />
      </Fragment>
    );
  }
}

Topbar.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  isSidebarOpen: PropTypes.bool,
  onToggleSidebar: PropTypes.func,
  action: PropTypes.object,
  cognitoUser: PropTypes.object
};

function mapStateToProps(state) {
  return {
    authenticated: state.auth.authenticated,
    cognitoUser: state.auth.cognitoUser
  };
}

// approach #1
// return {
//   ...bindActionCreators({ logoutAction }, dispatch),
//   dispatch
// };

// approach #2
function mapDispatchToProps(dispatch) {
  return {
    action: bindActionCreators({ logoutAction }, dispatch)
  };
}

Topbar.defaultProps = {
  onToggleSidebar: () => {}
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  compose(
    withRouter,
    withStyles(styles)
  )(Topbar)
);
